import { Stack } from "@similarweb/ui-components/foundations";

// fallow-ignore-next-line boundary-violation -- shared Lines of Business util lives in segments zone; move to app-shared pending
import { hasLinesOfBusinessSegments } from "app/services/segments/LinesOfBusinessUtils";

import { useCategoriesComparison } from "../../categories-context";

import { MarketingChannelsLobNoData } from "./common/MarketingChannelsLobNoData";
import { MarketingChannelsChannelsOverviewWidget } from "./MarketingChannelsChannelsOverviewWidget";
import { MarketingChannelsChannelTrafficWidget } from "./MarketingChannelsChannelTrafficWidget";
import { MarketingChannelsTrafficShareWidget } from "./MarketingChannelsTrafficShareWidget";
import { MarketingChannelsTrafficVolumesBySourceWidget } from "./MarketingChannelsTrafficVolumesBySourceWidget";
import { useMarketingChannelsQueries } from "./useMarketingChannelsQueries";

export const MarketingChannels = () => {
    const { isComparisonMode, categories } = useCategoriesComparison();
    const { data, isLoading, isError } = useMarketingChannelsQueries({ categories });

    // MMX is not available for custom industries that include a Line of Business (DRI-10608).
    const hasLinesOfBusiness = categories.some((categoryComparison) =>
        hasLinesOfBusinessSegments(categoryComparison.category.segments),
    );

    if (hasLinesOfBusiness) {
        return (
            <Stack
                data-automation="marketing-channels"
                gap="24px"
            >
                <MarketingChannelsLobNoData />
            </Stack>
        );
    }

    if (!isComparisonMode) {
        const { graph, totals } = data[categories[0].id] ?? {};

        return (
            <Stack
                data-automation="marketing-channels"
                gap="24px"
            >
                <MarketingChannelsTrafficShareWidget
                    isLoading={isLoading}
                    apiData={totals}
                />
                <MarketingChannelsTrafficVolumesBySourceWidget
                    isLoading={isLoading}
                    apiData={graph}
                />
            </Stack>
        );
    }

    return (
        <Stack
            data-automation="marketing-channels"
            gap="24px"
        >
            <MarketingChannelsChannelsOverviewWidget
                isLoading={isLoading}
                isError={isError}
                data={data}
                categories={categories}
            />
            <MarketingChannelsChannelTrafficWidget
                isLoading={isLoading}
                isError={isError}
                data={data}
                categories={categories}
            />
        </Stack>
    );
};
